<template>
  <v-container fluid>
    <material-card icon="mdi-calendar" inline title="View Events">
      <v-row class="fill-height">
        <v-col>
          <v-sheet height="64">
            <v-toolbar flat>
              <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                Today
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon small>
                  mdi-chevron-left
                </v-icon>
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon small>
                  mdi-chevron-right
                </v-icon>
              </v-btn>
              <v-toolbar-title v-if="$refs.calendar">
                {{ $refs.calendar.title }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                    <span>{{ typeToLabel[type] }}</span>
                    <v-icon right>
                      mdi-menu-down
                    </v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="type = 'day'">
                    <v-list-item-title>Day</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'week'">
                    <v-list-item-title>Week</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'month'">
                    <v-list-item-title>Month</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = '4day'">
                    <v-list-item-title>4 days</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-sheet>
          <v-sheet height="600" rounded="lg">
            <v-calendar
              ref="calendar"
              v-model="focus"
              color="accent"
              :events="events"
              :event-color="getEventColor"
              event-text-color="white"
              :type="type"
              @click:event="showEvent"
              @click:more="viewDay"
              :event-ripple="true"
            ></v-calendar>
            <v-menu v-model="selectedOpen" max-width="500px" :close-on-content-click="false" :activator="selectedElement" offset-x>
              <v-card color="grey lighten-4" min-width="350px" flat>
                <v-toolbar :color="selectedEvent.color" dark>
                  <v-btn icon><v-icon>mdi-information</v-icon></v-btn>
                  <v-toolbar-title class="pl-0" v-html="selectedEvent.name"></v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <span v-html="selectedEvent.details"></span>
                </v-card-text>
                <v-card-text v-if="attachefileCount > 0">
                  <label class="accent--text">Uploaded Documents</label>
                  <div class="mt-2" rounded="lg" v-for="(file, i) in selectedEvent.attachefile"
                    :key="i">

                    <v-btn elevation="1" class="mr-2" small default @click="download(file.urlPath)">
                      <v-icon left color="primary">mdi-download</v-icon>
                      {{ file.type }}
                    </v-btn>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn text color="secondary" @click="selectedOpen = false">
                    Ok
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-sheet>
        </v-col>
      </v-row>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import moment from 'moment'
import stores from '@/stores'
// import Utils from '@/utils'
import { mapGetters } from 'vuex'
export default {
  name: 'eventCalendarView',
  components: {
    MaterialCard
  },
  data () {
    return {
      isLoading: false,
      fromDate: moment().format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      academicYearID: '',
      franchiseeArr: [],
      inProgress: false,
      franchiseeID: '',
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      focus: '',
      colorValue: '',
      type: 'month',
      details: null,
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days'
      },
      events: [],
      colors: ['success', 'darkblue', 'pink'],
      user: stores.user.me,
      isStudent: false,
      attachefileCount: 0
    }
  },
  async created () {
    await this.onFranchiseeChange()
    if (this.user.userStudentMap && this.user.userStudentMap.studentAdmissionID) {
      this.isStudent = true
    }
  },
  watch: {
    franchisee: async function () {
      await this.onFranchiseeChange()
    },
    academicYear: async function () {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  mounted () {
    this.$refs.calendar.checkChange()
    this.onFranchiseeChange()
  },
  methods: {
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
          this.academicYears = this.academicYear.academicYear
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
      this.events = []
      this.save()
    },
    async save () {
      this.isLoading = true
      if (this.academicYearID && this.franchiseeID !== ' ') {
        try {
          this.fromDate = this.academicYears.toString().split('-')[0]
          this.toDate = this.academicYears.toString().split('-')[1]
          const { data } = await http.get(`${constants.API_URL}/api/communication/eventCalender`, {
            params: {
              academicYearID: this.academicYearID,
              franchiseeID: this.franchiseeID,
              fromDate: `${this.fromDate}-04-01`,
              toDate: `${this.toDate}-03-31`
            }
          })
          if (data.length === 0) {
            this.$dialog.error({
              text: 'No Data Found',
              title: 'No Data'
            })
          } else {
            this.photoGallery = data
            let eventsArr = []
            this.photoGallery.forEach(e => {
              let eventData = {}
              eventData.attachefile = []
              if (e.eventColorID === 3) {
                http.get(`${constants.API_URL}/api/communication/eventCalender/${e.id}`)
                  .then((res) => {
                    this.documentData = res.data
                    eventData.attachefile = this.documentData.eventDocumentsMaps
                  })
              }
              if (e.isActive === true) {
                eventData.start = moment(e.startDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
                eventData.end = moment(e.endDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
                eventData.name = `${e.eventColorSetting.name}: ${e.title}`
                eventData.details = `<h3 style="font-weight:bold;">${e.subTitle}</h3><h6>${e.descriptions}</h6>`
                if (e.eventColorID === 1) {
                  this.colorValue = 'success'
                } else if (e.eventColorID === 2) {
                  this.colorValue = 'darkblue'
                } else {
                  console.log(`${e.iconColor}`)
                  this.colorValue = `${e.eventColorSetting.iconColor}`
                }
                eventData.color = this.colorValue
                eventsArr.push(eventData)
              }
            })

            this.events = eventsArr
          }
          this.isLoading = false
        } catch (e) {
          this.isLoading = false
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          console.log('Error While Saving Data', errorMessage)
        }
      }
    },
    download: async function (i) {
      try {
        let url = await http.get(`${constants.API_URL}/api/staff/downloadurl?s3urlKey=${i}`)
        window.open(url.data)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    viewDay ({ date }) {
      this.focus = date
      this.type = 'day'
    },
    getEventColor (event) {
      return event.color
    },
    setToday () {
      this.focus = new Date()
    },
    prev () {
      this.$refs.calendar.prev()
    },
    next () {
      this.$refs.calendar.next()
    },
    showEvent ({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event
        this.attachefileCount = this.selectedEvent.attachefile.length
        this.selectedElement = nativeEvent.target
        setTimeout(() => {
          this.selectedOpen = true
        }, 10)
      }

      if (this.selectedOpen) {
        this.selectedOpen = false
        setTimeout(open, 10)
      } else {
        open()
      }

      nativeEvent.stopPropagation()
    }
  }
}
</script>
